import React, { useState, useEffect, useRef } from 'react';
import MetaTags from "react-meta-tags";
import '@fortawesome/fontawesome-free/css/all.min.css';

import { useParams, useHistory } from 'react-router-dom';
import ApiClient from '../BaseUrl/ApiClient';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import './BusinessDetail.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function BusinessDetail() {
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const { id } = useParams();
  const history = useHistory();

  const getBusinessDetails = async () => {
    if (!id) {
      setError('No business ID provided');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await ApiClient().get(`/business/admin/${id}`);

      if (response.data?.responseData?.business) {
        setBusiness(response.data.responseData.business);
      } else {
        throw new Error('Business data not found in response');
      }
    } catch (err) {
      console.error('Error fetching business details:', err);
      setError('Failed to load business details');
      toast.error('Failed to load business details');

      if (err.response?.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
        history.push('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBusinessDetails();
  }, [id]);

  const goBack = () => {
    history.push('/business-list');
  };

  const renderRatingStars = (rating) => {
    const numericRating = parseFloat(rating) || 0;
    return Array(5).fill().map((_, i) => {
      if (i < Math.floor(numericRating)) {
        return <i key={i} className="fas fa-star filled" />;
      } else if (i < numericRating) {
        return <i key={i} className="fas fa-star-half-alt filled" />;
      } else {
        return <i key={i} className="far fa-star" />;
      }
    });
  };

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };


  if (loading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: '100vh' }} // full viewport height
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading business details...</p>
      </div>
    );
  }


  if (error) {
    return (
      <div className="text-center py-5">
        <p className="text-danger">{error}</p>
        <Button color="primary" onClick={getBusinessDetails}>
          Retry
        </Button>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content custom-auth-page">
        <MetaTags>
          <title>Business Detail</title>
        </MetaTags>
        <Container >
          <Row >
            <Col md={12} >
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h4>Business Details</h4>
                   <Col xs={12} md={2} className="d-flex justify-content-end mt-3 mt-md-0">
                          <Button color="primary" onClick={goBack}>
                            Back to List
                          </Button>
                        </Col>
                </CardHeader>
                <CardBody >
                  {business && (
                    <div className='business-detail'>
                      <Row className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center bgcolor">
                        <Col xs={12} md={12} className="">
                          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100">
                            <div className="mb-3 mb-md-0 me-md-3">
                              {business.logoImage?.url ? (
                                <img
                                  src={business.logoImage.url}
                                  alt={business.businessName || "Business logo"}
                                  className="business-logo"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = '/default-logo.png';
                                  }}
                                />
                              ) : (
                                <div className="business-logo-placeholder text-muted">
                                  No logo available
                                </div>
                              )}
                            </div>

                            <div className='w-100'>
                              <h3 className="text-dark fw-semibold">
                                {business.businessName || 'No business name provided'}
                              </h3>
                              <p className="description mb-2">
                                <strong>User Name:</strong> {business.user?.name || 'N/A'}
                              </p>
                              <p className="description mb-2">
                                <strong>Email:</strong> {business.user?.email || 'N/A'}
                              </p>
                              {/* <p className="description mb-2">
                                <strong>Website:</strong>{' '}
                                {business.websiteLink ? (
                                  <a className='instagram-link' href={business.websiteLink} target="_blank" rel="noopener noreferrer">
                                    {business.websiteLink}
                                  </a>
                                ) : (
                                  'Not provided'
                                )}
                              </p> */}
                              {/* <p className="description deswidth mb-0">
                                {business.businessDescription || 'No description provided'}
                              </p> */}
                            </div>
                          </div>
                        </Col>

                       

                      </Row>

                      <Row className="mt-3">
                        <Col xs={12} md={6} className="mb-2 mb-md-0">
                          <p className='description'>
                            <strong>Location:</strong>{' '}
                            {business.businessLocation?.streetAddress || 'No address'}
                            {business.businessLocation?.city && `, ${business.businessLocation.city}`}
                            {business.businessLocation?.state && `, ${business.businessLocation.state}`}
                            {business.businessLocation?.postalCode && `, ${business.businessLocation.postalCode}`}
                          </p>
                        </Col>

                        {/* <Col xs={12} md={6} className="mb-2 mb-md-0">
                          <p className='description'>
                            <strong>Phone:</strong> {business.phone || 'Not provided'}
                          </p>
                        </Col> */}
                      </Row>

                      <Row className="mt-3">
                        <Col xs={12} md={6} className="mb-2 mb-md-0">
                          <p className='description'>
                            <strong>Operating Hours:</strong> {business.operatingHours || '-'}
                          </p>
                        </Col>
                        {/* <Col xs={12} md={6} className="mb-2 mb-md-0">
                          <p className='description'>
                            <strong>Instagram:</strong>{' '}
                            {business.instagramId ? (
                              <a
                                href={business.instagramId.startsWith('http') ? business.instagramId : `https://instagram.com/${business.instagramId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className='instagram-link'
                              >
                                {business.instagramId}

                              </a>
                            ) : (
                              'Not provided'
                            )}
                          </p>
                        </Col> */}

                      </Row>

                      <Row className="mt-3">
                        {/* <Col xs={12} md={6} className="mb-2 mb-md-0">
                          <p className='description'>
                            <strong>Daily Special Time:</strong> {business.dailySpecialTime || '-'}
                          </p>
                        </Col> */}
                        <Col xs={12} md={6} className="mb-2 mb-md-0">
                          <p className='description'>
                            <strong>Lunch Special Time:</strong> {business.lunchSpecialTime || '-'}
                          </p>
                        </Col>

                      </Row>

                      {/* <Row className="mt-3">
                        <Col xs={12} md={6}>
                          <p className='description'>
                            <strong>Subscription Type:</strong>{' '}
                            {business.subscriptionType ? business.subscriptionType.charAt(0).toUpperCase() + business.subscriptionType.slice(1) : 'Standard'}
                          </p>
                        </Col>
                      </Row> */}


                  

                      <div className="profile-section upcard reviews-section mt-4">
                        <h5 className="fw-bold mb-3">Rating & Reviews</h5>
                            <div className="profile-section upcard subscription-section mb-2 mt-4">

                        <Row>
                          <Col xs={12} md={4}>
                            <p className='description'>
                              <strong>Average Rating:</strong> {business.averageRating || '0'}
                            </p>
                          </Col>
                          <Col xs={12} md={4}>
                            <p className='description'>
                              <strong>Total Reviews:</strong> {business.totalReviews || '0'}
                            </p>
                          </Col>
                        </Row>
                      </div>

                        {business?.reviews?.length > 0 ? (
                          <div className="reviews-list">
                            {business.reviews.map((review) => (
                              <div key={review.id} className="review-item">
                                <div className="review-header">
                                  <strong>{review.user?.name || "Anonymous"}</strong>
                                  <span className="review-date">{formatDate(review.createdAt)}</span>
                                </div>
                               <div className="review-stars">
  {renderRatingStars(review.rating)}
</div>

                                {review.comment && (
                                  <div className="review-comment">
                                    <p>{review.comment}</p>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="no-reviews">No reviews yet.</p>
                        )}
                      </div>

                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default BusinessDetail;